import moment from 'moment-timezone'

export default ({ startDate, day, hour }) =>
  moment.utc(startDate).local().startOf('day').add(day, 'days').hour(hour)
